<script setup lang="ts"></script>

<template>
  <section class="footer-services">
    <a href="https://rc.shopping/">
      <img src="@/assets/images/rc-market.svg" alt="" />
      RC MARKET
    </a>
    <a href="https://pass.rc.today/profile">
      <img src="@/assets/images/rc-passport.svg" alt="" />
      RC PASSPORT
    </a>
  </section>
</template>

<style scoped lang="scss">
.footer-services {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: calc($base-space * 6);

  > a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: $base-space;
    @include body-s();
    color: var(--color-semantic-content-normal-contrast-secondary);
  }
}
</style>
